<template>
    <div class="faqElement">
        <div  class="question">{{ question }}</div>
        <div v-html="answer" class="answer" />
    </div>
</template>

<script>
    export default {
        props: ['question', 'answer'],
    }
</script>
